/* eslint-disable */
require("es6-promise").polyfill();
import queryString from "query-string";
import $ from "jquery";
import sortSelect from "./sortSelect";
import fetchResults from "./search/fetchResults";

export default class CheckboxFilters {
  constructor(checkboxesSelector, form, searchContainer, documentActiveClass) {
    this.checkboxes = document.querySelectorAll(checkboxesSelector);
    this.checkboxValue = [].slice.call(this.checkboxes);
    this.form = document.querySelector(form);
    this.searchContainer = document.querySelector(searchContainer);
    this.documentActiveClass = documentActiveClass;

    this.bindEventHandlers();
  }

  bindEventHandlers() {
    const self = this;

    // Handle filtering our results when we select a filter from the sidenav
    this.checkboxValue.forEach(el => {
      var checkbox = el.nextElementSibling;

      if (checkbox.checked) {
        $(el).addClass(this.documentActiveClass);
      }

      $(el).keypress(event => {
        if (event.which == 13) {
          if ($(el).is(":focus")) {
            this.CheckboxEvent(checkbox, this.searchContainer, el);
            this.SetupSubtopics(el, checkbox);
          }
        }
      });

      checkbox.addEventListener("change", () => {
        this.CheckboxEvent(checkbox, this.searchContainer, el);
        this.SetupSubtopics(el, checkbox);
      });
    });
  }

  CheckboxEvent(checkbox, searchContainer, el) {
    const paramName = checkbox.getAttribute("name");
    const paramValue = checkbox.value;
    $(el).toggleClass(this.documentActiveClass);
    checkbox.checked = $(el).hasClass(this.documentActiveClass);
    if ($(el).hasClass(this.documentActiveClass)) {
      $(this).attr("aria-checked", "true");
    } else {
      $(this).attr("aria-checked", "false");
    }

    // Only handle updating the query string and fetching results
    // via AJAX if at tablet or desktop
    if ($(window).outerWidth() > 767) {
      let form = $(el).closest("form");
      let data = form.serialize();

      let params = queryString.parse(location.search, {
        arrayFormat: "bracket",
        encode: false
      });

      params[paramName] = paramValue;

      if (checkbox.checked) {
        params[paramName] = paramValue;
      } else {
        params[paramName] = undefined;
      }

      // check if our start param exists
      // in which case we want to remove this so we can reset
      // the pagination back to 0 on our newly filtered results
      if (params["start"]) {
        params["start"] = undefined;
      }

      params = queryString.stringify(params, {
        arrayFormat: "bracket",
        encode: false
      });

      const url = `${location.origin}${location.pathname}?${params}`;
      window.history.pushState({}, "filter", url);


      // if #search-page-filters exists set the url to be the form action
      // likewise for doc search form)
      let fetchURL = $("#search-page-filters").length || $(".document-search-form").length ? form.attr("action") : url;
      fetchResults(fetchURL, data, this.searchContainer, el);
    }
  }

  SetupSubtopics(el, checkbox) {
    if ($(el).closest("[data-subtopics-link]").length) {
      let subtopicLink = $(el)
        .closest("[data-subtopics-link]")
        .data("subtopics-link");

      let form = $(el).closest("form");
      let data = form.serialize();
      let dataArray = form.serializeArray();

      $.ajax({
        url: subtopicLink,
        data: data
      })
        .done(response => {
          // Set the subtopics field html on success
          $(el).closest('form').find('.field--subtopics').html(response);

          const documentFilter = new CheckboxFilters(
            ".field--subtopics .checkbox-toggle",
            ".document-search-form",
            "[data-inject='search-results']",
            "checkbox-toggle--active"
          );
        })
        .fail(response => {
          console.warn(response);
        });
    }
  }
}

/* eslint-enable */
